"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rename = exports.filter = void 0;
/* eslint-disable no-param-reassign */

var filter = exports.filter = function filter(object, keysToFilter, key, val) {
  if (keysToFilter.indexOf(key) !== -1) {
    delete object[key];
  } else {
    object[key] = val;
  }
};
var rename = exports.rename = function rename(object, fromTo, key, val) {
  if (fromTo[key]) {
    object[fromTo[key]] = val;
    delete object[key];
  } else {
    object[key] = val;
  }
};